"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('services/hubService',["require", "exports", "controllers/hubController"], function (require, exports, hubController) {
    "use strict";

    var HubService = function () {
        function HubService() {
            _classCallCheck(this, HubService);
        }

        _createClass(HubService, [{
            key: "getHubAccess",
            value: function getHubAccess(hubName) {
                return hubController.getHubAccess({ hubName: hubName });
            }
        }]);

        return HubService;
    }();

    return new HubService();
});
//# sourceMappingURL=hubService.js.map;
